import { createFileRoute } from '@tanstack/react-router'
import { CertificatePage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'

export const Route = createFileRoute('/it/certificati/$certificateId')({
  loader: ({ params }) =>
    loadPageData({ data: { kind: 'certificate', locale: 'it', params } }),
  head: ({ loaderData }) => loaderData?.head ?? {},
  component: RouteComponent,
})

function RouteComponent() {
  const { certificateId } = Route.useParams()
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <CertificatePage certificateId={certificateId} />
    </CatalogProvider>
  )
}
